var map = {
	"./EternaLegacyImg.png": 371,
	"./Play_on_Clique.png": 1037,
	"./agld.png": 1038,
	"./awns.png": 372,
	"./bg.png": 1039,
	"./bg1.jpg": 1040,
	"./blast.png": 1041,
	"./blue-loader.svg": 1042,
	"./circle-grey.svg": 1043,
	"./circle.svg": 1044,
	"./coinbaseWalletIcon.svg": 368,
	"./console1.png": 1045,
	"./console2.png": 1046,
	"./console3.png": 1047,
	"./console4.png": 1048,
	"./dropdown-blue.svg": 1049,
	"./dropdown.svg": 1050,
	"./dropup-blue.svg": 1051,
	"./ethereum-logo.png": 1052,
	"./forest-bg.png": 1053,
	"./forest1.png": 373,
	"./forest2.png": 1054,
	"./forest3.png": 1055,
	"./forest4.png": 1056,
	"./forest5.png": 1057,
	"./game-detail-bg.png": 1058,
	"./link.png": 1059,
	"./link.svg": 1060,
	"./logo.png": 299,
	"./magnifying-glass.svg": 1061,
	"./matic-token-icon.png": 1062,
	"./menu.svg": 1063,
	"./metamask.png": 374,
	"./next.svg": 1064,
	"./nft1.png": 1065,
	"./nft2.png": 1066,
	"./nft3.png": 1067,
	"./nft4.png": 1068,
	"./noise.png": 1069,
	"./plus-blue.svg": 1070,
	"./plus-grey.svg": 1071,
	"./popular-game1.png": 1072,
	"./popular-game2.png": 1073,
	"./popular-game3.png": 1074,
	"./portisIcon.png": 369,
	"./question-mark.svg": 1075,
	"./question.svg": 1076,
	"./spinner.svg": 1077,
	"./star-group.png": 375,
	"./star.svg": 1078,
	"./step.png": 1079,
	"./tip.png": 1080,
	"./token-list-logo.png": 1081,
	"./token-logo.png": 1082,
	"./tokenlistsgrouped.png": 1083,
	"./top.png": 1084,
	"./trustWallet.png": 1085,
	"./upcoming_game_1.jpg": 1086,
	"./upcoming_game_1.png": 1087,
	"./upcoming_game_2.png": 1088,
	"./upcoming_game_3.png": 1089,
	"./wallet.svg": 1090,
	"./walletConnectIcon.svg": 370,
	"./website.svg": 1091,
	"./x.svg": 1092,
	"./zk_net.svg": 1093
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 529;